import { useEffect } from 'react';

import { useAccessToken } from '@mint-lib/auth';
import { Socket } from 'socket.io-client';

import { dataFileSocketManager } from '../utils/dataFileSocketManager.js';

type Options = {
  onCleanup?: (socket: Socket) => void;
};

export const useDataFileSocket = (dataFileId: string, options?: Options) => {
  const authToken = useAccessToken();

  const socket = dataFileSocketManager.get(
    authToken || '',
    dataFileId,
    options?.onCleanup,
  );

  useEffect(() => {
    return () => {
      dataFileSocketManager.release(dataFileId);
    };
  }, [dataFileId]);

  return socket;
};
